import { InjectionToken } from '@angular/core';

export interface SentryConfig {
    enabled: boolean;
    dsn: string;
    environment: 'production' | 'localhost';
    allowSessionReplay: boolean;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
}

export const SENTRY_CONFIG = new InjectionToken<SentryConfig>('sentryConfig', {
    providedIn: 'root',
    factory: () => ({
        enabled: false,
        dsn: '',
        environment: 'localhost',
        allowSessionReplay: false,
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    }),
});
